
import { defineComponent, reactive } from 'vue'

export default defineComponent({
  setup() {
    const phone = reactive({
      num: '',
      code: ''
    })
    const phoneLoginAction = () => {
      console.log('phone登录')
    }
    return {
      phone,
      phoneLoginAction
    }
  }
})
